import {PAYGO_API_KEY, PAYGO_API_SECRET} from '../credentials'

export async function generateCardHash(card) {
    // Configura credencias PayGo
    await configurePayGo();
    
    // Chama a função no index.html que gera o hash do cartão
    window['cardHash'](card);
}

export async function configurePayGo() {
    // Reseta a variavel de configuração da PayGo
    localStorage.setItem('isPayConfigured', false);

    // Chama a função no index.html que configura a PayGo
    window['configurePayGo'](PAYGO_API_KEY, PAYGO_API_SECRET);

    // Aguarda em loop a configuração da PayGo
    while(!localStorage.getItem('isPayConfigured')){
        await sleep(100);
    }
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}